import { Controller } from "@hotwired/stimulus"

// Frames the segment of the iOS version bar whose legend entry is hovered.
// A frame, not dimming the others: the oldest versions are a few pixels wide
// and would vanish among dimmed neighbours.
const FRAME = ["z-10", "outline-2", "outline-offset-2", "outline-orange-500"]

export default class extends Controller {
  static targets = ["segment"]

  highlight({ params: { index } }) {
    this.segmentTargets.forEach((segment) => {
      FRAME.forEach((name) => segment.classList.toggle(name, Number(segment.dataset.index) === index))
    })
  }

  clear() {
    this.segmentTargets.forEach((segment) => segment.classList.remove(...FRAME))
  }
}
